import type { FC, ReactElement, ReactNode } from "react"

import { buildCssClassName } from "@/3514/utils"

import { typographyConfig } from "./typography.config"
import {
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight
} from "./typography.types"

const { sizesMap, colorsMap, fontWeightsMap, familiesMap, alignmentMap } = typographyConfig

type TTypographyProps = {
    tag?: ETypographyTag
    size?: ETypographySize
    color?: ETypographyColor
    weight?: ETypographyWeight
    alignment?: ETypographyAlignment
    family?: ETypographyFamily
    isItalic?: boolean
    isPretty?: boolean
    withHyphens?: boolean
    className?: string
    text: string | ReactNode
}

const Component: FC<TTypographyProps> = ({
    tag: Tag = ETypographyTag.Paragraph,
    family = ETypographyFamily.Nunito,
    size = ETypographySize.Medium,
    color = ETypographyColor.Black,
    weight = ETypographyWeight.Default,
    alignment = ETypographyAlignment.Left,
    isItalic: italic = false,
    isPretty = false,
    withHyphens = false,
    className,
    text
}: TTypographyProps): ReactElement => (
    <Tag
        className={buildCssClassName({
            [className]: className,
            [sizesMap[size]]: size,
            [colorsMap[color]]: color,
            [fontWeightsMap[weight]]: weight,
            [alignmentMap[alignment]]: alignment,
            [familiesMap[family]]: family,
            "text-pretty": isPretty,
            "hyphens-auto": withHyphens,
            italic
        })}
    >
        {text}
    </Tag>
)

Component.displayName = "Typography"

export { Component as Typography, type TTypographyProps }
